export default __webpack_public_path__ + "static/media/detail_main_img_2_2.9b7192b7.png";